// extracted by mini-css-extract-plugin
module.exports = {"client":"styles_client__3ra_P","icon":"styles_icon__1owUj","data":"styles_data__AGR5q","title":"styles_title__1hZZV","info":"styles_info__3oPkZ"};